import React from "react";
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";
import { getImageUrl } from "helpers/Image.helper";
import { getFlagByCountryCode, getStudentNickname } from "helpers/String.helper";

// 스켈레톤 컴포넌트
const SkeletonCard = () => (
    <div className="bg-gray-50 p-3 sm:p-4 rounded-lg sm:rounded-xl animate-pulse">
        <div className="flex flex-row sm:flex-col h-full justify-between sm:justify-start">
            <div className="bg-gray-200 rounded h-3 sm:h-4 w-20 sm:w-24 mb-0 sm:mb-2 mr-2 sm:mr-0"></div>
            <div className="bg-gray-200 rounded h-6 sm:h-8 w-12 sm:w-16"></div>
        </div>
    </div>
);

const SkeletonSection = () => (
    <section className="bg-white rounded-2xl shadow-sm overflow-hidden mb-4 sm:mb-6 animate-pulse">
        <div className="p-4 sm:p-6 border-b border-gray-100">
            <div className="bg-gray-200 rounded h-6 sm:h-7 w-48 sm:w-56"></div>
        </div>
        <div className="p-3 sm:p-4 md:p-6">
            <div className="space-y-4 sm:space-y-6">
                <div>
                    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                        <SkeletonCard />
                        <SkeletonCard />
                    </div>
                </div>
            </div>
        </div>
    </section>
);

const IndexComponent = (props: any) => {
    const { info, isLoading, handleShowStudentInfoPopup } = props;

    return (
        <>
            <main className="bg-gray-50 min-h-screen">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-6">
                    {/* 제목은 항상 표시 */}
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">
                        {getLanguageValue(PAGE_TYPE.STUDENT, "castingSummary.txtTitle")}
                    </h2>

                    {isLoading ? (
                        /* 캐스팅 정보 섹션 스켈레톤 */
                        <SkeletonSection />
                    ) : (
                        <div className="space-y-6">
                            {/* 캐스팅 여부 토글 섹션 */}

                            {/* 내 캐스팅 정보 섹션 */}
                            <section className="bg-white rounded-2xl shadow-sm overflow-hidden mb-4 sm:mb-6">
                                <div className="p-4 sm:p-6 border-b border-gray-100">
                                    <h2 className="text-lg sm:text-xl font-bold text-gray-900">
                                        {getLanguageValue(PAGE_TYPE.STUDENT, "castingSummary.txtCastingSectionTitle")}
                                    </h2>
                                </div>

                                <div className="p-3 sm:p-4 md:p-6">
                                    <div className="space-y-4 sm:space-y-6">
                                        {/* 대화 섹션 */}
                                        <div>
                                            <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                                                {/* 대기중인 요청 */}
                                                <div className="bg-gray-50 p-3 sm:p-4 rounded-lg sm:rounded-xl 
                                                hover:bg-gray-100 transition-all duration-200 
                                                transform hover:-translate-y-1 shadow-sm hover:shadow">
                                                    <div className="flex flex-row sm:flex-col h-full justify-between sm:justify-start">
                                                        <h3 className="text-xs sm:text-sm font-medium text-gray-500 
                                                        mb-0 sm:mb-2 mr-2 sm:mr-0">
                                                            {getLanguageValue(PAGE_TYPE.STUDENT, "castingSummary.txtCastingSectionWaitingRequest")}
                                                        </h3>
                                                        <p className="text-lg sm:text-xl lg:text-2xl font-bold text-[#CF3688]">
                                                            {info.waitingChattingCount?.toLocaleString() || "N/A"}
                                                        </p>
                                                    </div>
                                                </div>

                                                {/* 진행중인 대화 */}
                                                <div className="bg-gray-50 p-3 sm:p-4 rounded-lg sm:rounded-xl 
                                                hover:bg-gray-100 transition-all duration-200 
                                                transform hover:-translate-y-1 shadow-sm hover:shadow">
                                                    <div className="flex flex-row sm:flex-col h-full justify-between sm:justify-start">
                                                        <h3 className="text-xs sm:text-sm font-medium text-gray-500 
                                                        mb-0 sm:mb-2 mr-2 sm:mr-0">
                                                            {getLanguageValue(PAGE_TYPE.STUDENT, "castingSummary.txtCastingSectionChatting")}
                                                        </h3>
                                                        <p className="text-lg sm:text-xl lg:text-2xl font-bold text-[#CF3688]">
                                                            {info.onChattingCount?.toLocaleString() || "N/A"}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* 캐스팅 매니저에게 대화 요청을 받은 지망생 목록 */}
                            {/* {info?.requestingReceivedStudentList?.length > 0 && (
                                <section className="bg-white rounded-2xl shadow-sm overflow-hidden mb-4 sm:mb-6">
                                    <div className="p-4 sm:p-6 border-b border-gray-100">
                                        <h2 className="text-lg sm:text-xl font-bold text-gray-900">
                                            {getLanguageValue(PAGE_TYPE.STUDENT, "castingSummary.txtTraineeListTitle")}
                                            ({info?.requestingReceivedStudentList?.length})
                                        </h2>
                                    </div>
                                    <div className="p-4 sm:p-6">
                                        <div className="overflow-x-auto">
                                            <div className="flex gap-1">
                                                {info?.requestingReceivedStudentList?.map((student: any) => (
                                                    <div key={student.id} className="w-[100px] sm:w-[125px] lg:w-[150px] flex-shrink-0 cursor-pointer"
                                                        onClick={() => handleShowStudentInfoPopup(student?.id)}
                                                    >
                                                        <div className="flex flex-col items-center">
                                                            <div className="rounded-full overflow-hidden w-14 h-14 sm:w-16 sm:h-16 flex-shrink-0 border-2 border-gray-100 relative">
                                                                <img
                                                                    src={getImageUrl(student?.profileImageInfo)}
                                                                    alt={getStudentNickname(student)}
                                                                    className="w-full h-full object-cover"
                                                                />
                                                                <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2">
                                                                    {getFlagByCountryCode(student?.countryInfo?.code)}
                                                                </div>
                                                            </div>
                                                            <div className="mt-2 text-center w-full">
                                                                <p className="text-gray-900 text-xs truncate px-2">
                                                                    {getStudentNickname(student)}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            )} */}
                        </div>
                    )}
                </div>
            </main>
        </>
    );
};

export default IndexComponent;